import {useEffect, useState} from 'react';
import {useModal} from '../../model/ctx/ManagementDashboard.context';
import * as S from './ManagementTable.style';

export default function ManagementTable({ columns, data, page }) {
    const [toggle, setToggle] = useState({ toggle: false, userId: null });
    const { openModal, closeModal } = useModal();

    const handleModalOpen = (modalType, id, sinorYn = false, queryVariant) => {
        //queryVariant - photoAuth,report-member,report-content,'approve-gathering','approve-join','gathering-account','order'

        switch (modalType) {
            case 'userDetail':
                openModal(modalType, { userId: id, setToggle: setToggle, sinorYn: sinorYn }, [queryVariant, page]);
                break;
            case 'reportContent':
                openModal(modalType, { id: id, setToggle: setToggle }, [queryVariant, page]);
                break;

            default:
                break;
        }
    };

    useEffect(() => {
        if (!toggle.toggle) {
            closeModal();
        }
    }, [toggle]);

    return (
        <S.TableContainer>
            <S.Table>
                <thead>
                    <tr>
                        {columns.map(({ key, label }) => (
                            <S.Th key={key}>{label}</S.Th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data.length > 0 ? (
                        data.map((row, idx) => {
                            return (
                                <tr key={row.user_id || idx}>
                                    {columns.map((col, idx) => {
                                        const value = row[col.key];
                                        const alertCode = 'alertCode' in col ? row[col.alertCode] : false;
                                        const routerParamsId = 'routeParamsKey' in col ? row[col.routeParamsKey] : null;

                                        const hasModalRender =
                                            'modalRender' in col ? col.modalRender(value, handleModalOpen, col.modalType, row[col.modalProps], row.report_app, col.queryVariant) : false;
                                        const hasTextColorRender = 'textColorRender' in col ? col.textColorRender(value, alertCode) : false;
                                        const hasImageRender = 'imageRender' in col ? col.imageRender(value) : false;
                                        const hasRouterRender = 'routerRender' in col ? col.routerRender(value, routerParamsId) : false;
                                        const hasFormatter = 'formatter' in col ? col.formatter(value) : value;

                                        const sideEffect = hasModalRender || hasTextColorRender || hasImageRender || hasRouterRender || hasFormatter;
                                        return <S.Td key={idx}>{sideEffect ? sideEffect : value}</S.Td>;
                                    })}
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <S.Td colSpan={columns.length}>데이터가 없습니다.</S.Td>
                        </tr>
                    )}
                </tbody>
            </S.Table>
        </S.TableContainer>
    );
}
